export function slugifyDriverName(name) {
    return String(name || "fahrer")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "") || "fahrer";
}

export function driverStatsPath(row, seasonKey = "active") {
    const driverId = row?.driver_id;
    const name =
        row?.driver_name_snapshot ||
        row?.display_name_snapshot ||
        row?.driver_name ||
        row?.iracing_name ||
        "fahrer";

    const slug = driverId
        ? `${driverId}-${slugifyDriverName(name)}`
        : slugifyDriverName(name);

    const qs = new URLSearchParams();
    if (seasonKey) qs.set("season", seasonKey);

    return `/stats/${slug}?${qs.toString()}`;
}